function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShipped = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M28.418,6.137c1.288,0.048 2.245,1.487 1.839,2.767c-0.156,0.49 -0.573,1.059 -0.573,1.059c-5.472,5.532 -10.737,11.2 -16.311,16.773c0,0 -0.227,0.209 -0.497,0.03l-1.263,-0.997c-2.712,-2.169 -5.423,-4.338 -8.135,-6.507c-0.219,-0.199 -0.283,-0.314 -0.402,-0.492c-0.847,-1.268 -0.214,-3.355 1.381,-3.48c1.15,-0.09 2.12,0.89 3.136,1.703l5.19,4.15c4.628,-4.708 9.014,-9.721 13.858,-14.259c0.487,-0.44 1.105,-0.747 1.777,-0.747Z",
    style: {
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShipped);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shipped.8e151285467782691ff7e83f65b5daa9.svg";